module.exports = __webpack_public_path__ + "static/media/leaderboard-bg.7f0d6d63.png";